import { MTextField, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { KeysTabsAnalysis } from "@app/types/samples.types";
import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";

interface AlfaBetaFormProps {
  mode: string;
}

const AlfaBetaForm = ({ mode }: AlfaBetaFormProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;
  const form = useFormContext();
  const parts = form.watch("part");
  const analysisValue = form.watch("analysis");
  
  // Manejar tanto array como objeto único
  const analysisCode = Array.isArray(analysisValue) 
    ? analysisValue[0]?.codigo 
    : analysisValue?.codigo;
    
  const isBTorBR = [
    KeysTabsAnalysis.BR,
    KeysTabsAnalysis.BT,
    KeysTabsAnalysis.BPP,
  ].includes(analysisCode);
  const isBPP = analysisCode === KeysTabsAnalysis.BPP;

  // Filtrar la parte "SO" cuando el análisis es BPP (Beta partículas de polvo)
  const filteredParts = isBPP 
    ? parts?.filter((part: any) => part.parte !== "SO") 
    : parts;

  return (
    <>
      {filteredParts &&
        filteredParts.length > 0 &&
        filteredParts.map((part, index) => (
          <>
            <Grid item xs={12} mt={2}>
              <Typography variant="tagText">Parte {part.parte}</Typography>
            </Grid>
            <ResponsiveFormContainer key={index} columns={5} mt={1}>
              {(isBPP || (isBTorBR && part.parte == "SO")) && (
                <MTextField
                  name={`parts[${part.id}].efficiency`}
                  label="Eficiencia"
                  placeholder="Eficiencia"
                  type="number"
                  validation={{
                    required: "Término independiente es requerido",
                  }}
                  fullWidth
                  disabled={isView}
                />
              )}
              <MTextField
                name={`parts[${part.id}].a`}
                label="Término independiente"
                placeholder="Término independiente"
                type="number"
                validation={{ required: "Término independiente es requerido" }}
                fullWidth
                disabled={isView}
              />
              <MTextField
                name={`parts[${part.id}].x`}
                label="X"
                placeholder="X"
                type="number"
                validation={{ required: "X es requerido" }}
                fullWidth
                disabled={isView}
              />
              <MTextField
                name={`parts[${part.id}].x2`}
                label="X2"
                placeholder="X2"
                type="number"
                validation={{ required: "X2 es requerido" }}
                fullWidth
                disabled={isView}
              />
              <MTextField
                name={`parts[${part.id}].x3`}
                label="X3"
                placeholder="X3"
                type="number"
                validation={{ required: "X3 es requerido" }}
                fullWidth
                disabled={isView}
              />
              <MTextField
                name={`parts[${part.id}].x4`}
                label="X4"
                placeholder="X4"
                type="number"
                validation={{ required: "X4 es requerido" }}
                fullWidth
                disabled={isView}
              />
            </ResponsiveFormContainer>
          </>
        ))}
    </>
  );
};

export default AlfaBetaForm;
